import { render, staticRenderFns } from "./ReceiptsListFilter.vue?vue&type=template&id=50ac4f92"
import script from "./ReceiptsListFilter.vue?vue&type=script&lang=js"
export * from "./ReceiptsListFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports